import React from 'react';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';

import HiddenContracts from '@/pages/(main)/dashboard/hidden-contracts/page';
import Dashboard from '@/pages/(main)/dashboard/page';
import MainLayout from '@/pages/(main)/layout';
import Contacts from '@/pages/(main)/setting/contacts/page';
import SettingLayout from '@/pages/(main)/setting/layout';
import PersonalSettings from '@/pages/(main)/setting/personal-settings/page';
import CallbackHubspot from '@/pages/callback/hubspot/page';
// import CallbackSg from '@/pages/callback/sg/page';
import TemplateCreate from '@/pages/console/template/create/page';
import TemplateEdit from '@/pages/console/template/edit/page';
import TemplateList from '@/pages/console/template/list/page';
import Contract from '@/pages/contract/page';
import Download from '@/pages/download/page';
import Hubspot from '@/pages/hubspot/page';
import Layout from '@/pages/layout';

import Prepare from '@/pages/prepare/page';
import Preview from '@/pages/preview/page';
import Share from '@/pages/share/page';
import Signin from '@/pages/signin/page';
import Verify from '@/pages/verify/page';
const routerConfig: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/signin',
        element: <Signin />
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            path: '/',
            element: <Dashboard />
          },
          {
            path: '/dashboard',
            element: <Dashboard />
          },
          {
            path: '/dashboard/hidden-contracts',
            element: <HiddenContracts />
          },
          {
            path: '/setting',
            element: <SettingLayout />,
            children: [
              { path: 'contacts', element: <Contacts /> },
              { path: 'personal-settings', element: <PersonalSettings /> }
            ]
          }
        ]
      },
      {
        path: '/console/template',
        children: [
          { path: 'list', element: <TemplateList /> },
          { path: 'create/:id', element: <TemplateCreate /> },
          {
            path: ':id',
            element: <TemplateEdit />
          }
        ]
      },
      {
        path: '/contract/:id',
        element: <Contract />
      },
      {
        path: '/share/:id',
        element: <Share />
      },
      {
        path: '/prepare/:id',
        element: <Prepare />
      },
      {
        path: '/preview/:id',
        element: <Preview />
      },

      {
        path: '/verify',
        element: <Verify />
      },
      {
        path: '/download/:id',
        element: <Download />
      },
      {
        path: '/hubspot',
        element: <Hubspot />
      }
    ]
  },
  {
    path: '/callback',
    children: [
      {
        path: 'hubspot',
        element: <CallbackHubspot />
      }
      // {
      //   path: 'sg',
      //   element: <CallbackSg />
      // }
    ]
  }
];
const router = createBrowserRouter(routerConfig);

export const Router = () => {
  return <RouterProvider router={router} />;
};
